// extracted by mini-css-extract-plugin
export default {"container":"Clock_container__x-xKO","item":"Clock_item__lUDKe","day":"Clock_day__g4J0y","time":"Clock_time__c5-QZ"};